"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const getCampaignType_1 = require("../utils/getCampaignType");
const DevicePredicateLabel_1 = require("./DevicePredicateLabel");
const AudienceLabel = ({ segments, selectedSegment }) => {
    if (!selectedSegment) {
        return (React.createElement(src_1.Text, { text: "Send notification to all devices", size: "small", textStyle: {
                whiteSpace: 'pre-wrap',
            } }));
    }
    if (selectedSegment.__typename === 'DevicePredicateSegment') {
        const { predicate } = selectedSegment;
        if (getCampaignType_1.isComparisonPredicate(predicate)) {
            return React.createElement(DevicePredicateLabel_1.default, { predicate: predicate, textStyle: { fontSize: 15 } });
        }
        if (getCampaignType_1.isCompoundPredicate(predicate)) {
            const { booleanOperator, predicates } = predicate;
            return (React.createElement("div", { style: {
                    whiteSpace: 'pre-wrap',
                } }, predicates.map((subPredicate, index) => {
                if (getCampaignType_1.isComparisonPredicate(subPredicate)) {
                    return (React.createElement(React.Fragment, { key: index },
                        React.createElement(DevicePredicateLabel_1.default, { predicate: subPredicate, textStyle: { fontSize: 15 } }),
                        index < predicates.length - 1 ? (React.createElement(src_1.Badge, { color: src_1.charcoal, text: booleanOperator })) : ('')));
                }
                if (getCampaignType_1.isCompoundPredicate(subPredicate)) {
                    return subPredicate.predicates.map((comparisonPredicate, pIndex) => (React.createElement(React.Fragment, { key: `${index}-${pIndex}` },
                        React.createElement(DevicePredicateLabel_1.default, { textStyle: { fontSize: 15 }, predicate: comparisonPredicate }),
                        pIndex < subPredicate.predicates.length - 1 ? (React.createElement(src_1.Badge, { color: src_1.charcoal, style: {
                                marginRight: 4,
                            }, text: subPredicate.booleanOperator })) : index < predicates.length - 1 ? (React.createElement(src_1.Badge, { color: src_1.charcoal, style: {
                                marginRight: 4,
                            }, text: booleanOperator })) : (''))));
                }
            })));
        }
    }
    if (selectedSegment.__typename === 'DeviceListSegment') {
        const { createdAt, name, size } = selectedSegment.deviceList;
        const sizeAndCreatedAtCopy = `${size.toLocaleString()} row${size > 1 ? 's' : ''} ${String.fromCharCode(183)} Created ${new Date(createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`;
        return (React.createElement("div", { style: {
                display: 'flex',
                alignItems: 'center',
            } },
            React.createElement(src_1.Text, { size: "small", text: name }),
            React.createElement(src_1.Text, { size: "small", textStyle: { color: src_1.steel, marginLeft: 8 }, text: sizeAndCreatedAtCopy })));
    }
    if (selectedSegment.__typename === 'CompoundSegment') {
        const { condition, ids } = selectedSegment;
        if (ids.length > 0 && segments.length > 0) {
            return (React.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                } }, ids.map((id, index) => (React.createElement(React.Fragment, { key: index },
                React.createElement(src_1.Text, { text: segments.filter((s) => s.segmentId === id)[0].name, size: "small", textStyle: {
                        whiteSpace: 'pre-wrap',
                    } }),
                index !== ids.length - 1 ? (React.createElement(src_1.Badge, { color: src_1.charcoal, text: condition === 'ANY' ? 'OR' : 'AND', style: {
                        marginLeft: 8,
                        marginRight: 8,
                    } })) : null)))));
        }
    }
    return React.createElement("div", null);
};
exports.default = AudienceLabel;
